jQuery(document).ready(function ($) {
    'use strict';

    let $body = $(document.body);
    let $hide_next = $('.hide-next');
    $hide_next.prevAll().show();
    $hide_next.show();
    let show_all_text = $('.show-all').text();

    $body.on('click', '.show-all', function() {
        $(this).toggleClass('active');
        $(this).prev().toggleClass('active').find('.hide-next').nextAll().toggle();

        if ( $(this).hasClass('active') ) {
            $(this).text('Visa färre');
        } else {
            $(this).text(show_all_text);
        }
    });

});
//# sourceMappingURL=show-all.js.map
